export default class UpdateSpecOutEmailDetailsRequest {
    updatedAt: Date = new Date();
    emailTemplateId = '';
    emailBccUser = true;
    isTest = false;
    testEmailAddresses = '';
}
